import React from "react";
import { Stack, Tooltip, tooltipClasses } from "@mui/material";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import PersonIcon from "@mui/icons-material/Person";
import PowerInputIcon from "@mui/icons-material/PowerInput";
import styled from "styled-components";

const NewLanguagesText = styled.p`
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0;
    margin-top: 0;
`;

const LinesIcon = styled(DensityMediumIcon)`
    font-size: 16px;
    opacity: 0.4;
    margin-right: 6px;
`;

const FilesIcon = styled(FileOpenIcon)`
    font-size: 16px;
    opacity: 0.4;
    margin-right: 6px;
`;

const UsersIcon = styled(PersonIcon)`
    font-size: 16px;
    opacity: 0.4;
    margin-right: 6px;
`;

const NoLanguagesText = styled.h2`
    font-size: 14px;
    font-weight: 300;
    opacity: 0.3;
`;

const NoLanguagesIcon = styled(PowerInputIcon)`
    font-size: 38px;
    opacity: 0.3;
`;

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.tooltip,
        fontSize: 11,
    },
}));

const UpskillingMetrics = ({ data, variant, isTeam }) => {
    if (!data || data.length === 0) {
        if (variant === "new")
            return (
                <Stack direction="column" justifyContent="center" alignItems="center">
                    <NoLanguagesIcon />
                    <NoLanguagesText>No new languages used last week</NoLanguagesText>
                </Stack>
            );
        if (variant === "expected")
            return (
                <Stack direction="column" justifyContent="center" alignItems="center">
                    <NoLanguagesIcon />
                    <NoLanguagesText>No expected languages used last week</NoLanguagesText>
                </Stack>
            );
    }

    return data.map((entry) => {
        return (
            <Stack container direction="row" spacing={2} pb={0.5} key={entry.language}>
                <NewLanguagesText style={{ minWidth: "76px" }}>{entry.language}</NewLanguagesText>
                <LightTooltip title="Lines of code">
                    <Stack item direction="row">
                        <LinesIcon />
                        <NewLanguagesText style={{ minWidth: "36px" }}>
                            {entry.lines}
                        </NewLanguagesText>
                    </Stack>
                </LightTooltip>
                <LightTooltip title="Files">
                    <Stack item direction="row">
                        <FilesIcon />
                        <NewLanguagesText style={{ minWidth: "36px" }}>
                            {entry.files}
                        </NewLanguagesText>
                    </Stack>
                </LightTooltip>
                {isTeam && (
                    <LightTooltip title="Users">
                        <Stack item direction="row">
                            <UsersIcon />
                            <NewLanguagesText style={{ minWidth: "36px" }}>
                                {entry.users}
                            </NewLanguagesText>
                        </Stack>
                    </LightTooltip>
                )}
            </Stack>
        );
    });
};

export default UpskillingMetrics;
